"use client";

import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useState } from "react";
import SectionHeader from "./SectionHeader";

export default function LinksGrid({
  items = [], // [{ label: "Ankara Otelleri", href: "/ankara/oteller" }, ...]
  title,
  className = "",
  gridCols = {
    mobile: 1,
    tablet: 2,
    desktop: 3,
    large: 4,
  },
  shownImage = false,
  enableExpand = true, // Yeni prop: expand özelliğini aktif/pasif yapar
  rowLimit = 5, // Yeni prop: kaç row'dan sonra expand gösterileceği
}) {
  const [showAll, setShowAll] = useState(false);

  const getGridColsClass = () => {
    const mobile = gridCols.mobile || 1;
    const tablet = gridCols.tablet || 2;
    const desktop = gridCols.desktop || 3;
    const large = gridCols.large || 4;

    return `grid grid-cols-${mobile} w-full gap-6 md:grid-cols-${tablet} lg:grid-cols-${desktop} xl:grid-cols-${large}`;
  };

  // Row sayısını hesapla
  const calculateRowCount = () => {
    const mobile = gridCols.mobile || 1;
    const tablet = gridCols.tablet || 2;
    const desktop = gridCols.desktop || 3;
    const large = gridCols.large || 4;

    // Desktop grid'e göre row sayısını hesapla (en yaygın kullanım)
    const itemsPerRow = desktop;
    return Math.ceil(items.length / itemsPerRow);
  };

  // Expand özelliği için row sayısını kontrol et
  const currentRowCount = calculateRowCount();
  const shouldShowExpand = enableExpand && currentRowCount > rowLimit;

  // Kaç item gösterileceğini hesapla (rowLimit kadar row için)
  const itemsToShow =
    shouldShowExpand && !showAll
      ? rowLimit * (gridCols.desktop || 3) // Desktop grid'e göre
      : items.length;

  const displayedItems =
    shouldShowExpand && !showAll ? items.slice(0, itemsToShow) : items;

  return (
    <section className="space-y-4 lg:space-y-6 xl:space-y-12">
      {title && <SectionHeader title={title} />}
      <div className="flex w-full flex-col items-start gap-6 lg:flex-row lg:gap-8">
        {shownImage && (
          <div className="relative aspect-[252/142] w-full lg:w-full lg:max-w-[252px]">
            <Image
              src=""
              alt="image"
              fill
              className="rounded-lg object-cover transition-transform"
              priority={false}
            />
          </div>
        )}
        <ul className={getGridColsClass()}>
          {displayedItems.map((it, i) => (
            <li key={i}>
              <Link
                href={it.href || "#"}
                title={it.label}
                className="block cursor-pointer truncate text-lg font-medium text-black transition"
              >
                {it.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Expand/Collapse Button */}
      {shouldShowExpand && (
        <div className="flex w-full items-center justify-start md:justify-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-primary flex cursor-pointer items-center justify-center gap-2 text-base font-medium"
          >
            {showAll ? (
              <>
                <span className="font-medium">Daha Az Göster</span>
                <FontAwesomeIcon
                  className="h-4 w-4"
                  icon={byPrefixAndName.far["chevron-up"]}
                />
              </>
            ) : (
              <>
                <span className="font-medium">Tümünü Göster</span>
                <FontAwesomeIcon
                  className="h-4 w-4"
                  icon={byPrefixAndName.far["chevron-down"]}
                />
              </>
            )}
          </button>
        </div>
      )}
    </section>
  );
}
